import { render } from "./ListasSongs.vue?vue&type=template&id=36596d07"
import script from "./ListasSongs.vue?vue&type=script&lang=js"
export * from "./ListasSongs.vue?vue&type=script&lang=js"

import "./ListasSongs.vue?vue&type=style&index=0&id=36596d07&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__